import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryStudyAttributes } from './generated/DiscoveryStudyAttributes';
import { model } from '../modelBuilder';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

interface DiscoveryStudy extends DiscoveryStudyAttributes {}

@model
class DiscoveryStudy extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryStudy' = 'DiscoveryStudy';
  get typename(): 'DiscoveryStudy' {
    return 'DiscoveryStudy';
  }

  static internalTypename: 'Discovery::Study' = 'Discovery::Study';
  get internalTypename(): 'Discovery::Study' {
    return 'Discovery::Study';
  }

  static filterType = 'StudyFilters!';
  static filters = {
    id: '[ID!]',
    projectId: '[ID!]',
    startDate: 'ISO8601DateTime',
    endDate: 'ISO8601DateTime',
  };

  static fields = {
    createdAt: attr({ readable: true }),
    default: attr({ readable: true }),
    discoveryResearchItemsCount: attr({ readable: true }),
    discoveryScriptsCount: attr({ readable: true }),
    endDate: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    startDate: attr({ readable: true }),
    status: attr({ readable: true }),
    studyTypeId: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    createdByUser: attr.belongsTo({ readable: true, typename: 'User' }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    studyType: attr.belongsTo({
      readable: true,
      typename: 'DiscoveryStudyType',
    }),
    discoveryResearchItems: attr.hasMany({ readable: true }),
    discoveryScripts: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  startDateLocal(timezone: string): dayjs.Dayjs {
    return dayjs(this.startDate).tz(timezone);
  }

  endDateLocal(timezone: string): dayjs.Dayjs {
    return dayjs(this.endDate).tz(timezone);
  }
}

export default DiscoveryStudy;
